import React from "react";
import {
    Zap,
    BarChart3,
    BookOpen,
    Video,
    LifeBuoy,
} from "lucide-react";

const benefits = [
    {
        icon: Zap,
        title: "5–15 Premium Signals Daily",
        body: "Receive consistent daily trade ideas across forex and gold so you can stay focused on execution, not hunting for setups.",
    },
    {
        icon: BarChart3,
        title: "High Accuracy Analysis",
        body: "Access structured, repeatable market analysis from experienced traders — so every signal has a reason behind it.",
    },
    {
        icon: BookOpen,
        title: "Full Education + Exclusive E-Book",
        body: "Learn the logic behind every setup. Build real trading confidence with our private members' e-book and lesson library.",
    },
    {
        icon: Video,
        title: "Daily Live Trading Sessions",
        body: "Watch live market analysis and real-time decisions. Pick up reading skills you'll never get from random YouTube clips.",
    },
    {
        icon: LifeBuoy,
        title: "Complete Trading Support",
        body: "Get guidance, ask questions, and receive support whenever you need it. You're never trading alone again.",
    },
];

const BenefitsSection = () => {
    return (
        <section
            id="benefits"
            data-testid="benefits-section"
            className="bg-[#F2F2F2] py-20 md:py-28"
        >
            <div className="px-6 md:px-12 lg:px-24">
                <div className="text-center max-w-3xl mx-auto">
                    <span className="inline-block text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#0077b6]">
                        What's Inside
                    </span>
                    <h2
                        data-testid="benefits-heading"
                        className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-black"
                    >
                        What you'll get inside MTL
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
                        Everything we wish we had when we were starting out —
                        bundled, structured, and supported by a real community.
                    </p>
                </div>

                <div
                    data-testid="benefits-list"
                    className="mt-14 max-w-5xl mx-auto space-y-4"
                >
                    {benefits.map((b, i) => (
                        <div key={b.title} className="group relative">
                            {/* Blooming glow outside the border */}
                            <div
                                aria-hidden="true"
                                className="pointer-events-none absolute -inset-1 rounded-3xl bg-gradient-to-r from-[#0077b6] via-[#3aa6e0] to-[#0077b6] opacity-15 blur-xl group-hover:opacity-55 group-hover:blur-2xl transition-all duration-500"
                            />
                            <div
                                data-testid={`benefit-row-${i}`}
                                className="relative flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7 bg-white rounded-2xl border border-gray-200/70 p-6 sm:p-7 group-hover:shadow-xl group-hover:-translate-y-0.5 transition-all duration-300"
                            >
                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#0077b6] text-white shadow-lg shadow-[#0077b6]/30">
                                    <b.icon className="h-7 w-7" />
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-baseline gap-3">
                                        <span className="font-mono text-xs text-gray-400">
                                            0{i + 1}
                                        </span>
                                        <h3 className="font-display text-lg sm:text-xl font-semibold tracking-tight text-black">
                                            {b.title}
                                        </h3>
                                    </div>
                                    <p className="mt-1.5 text-sm sm:text-base text-gray-600 leading-relaxed">
                                        {b.body}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BenefitsSection;
